var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'dot-count text-center vs-avatar--count badgeNumber progress-multi dot-count-' +
    _vm.CssSuffix,style:(_vm.getTotalsClass())},[(_vm.ShowNumbers)?_c('span',{staticClass:"progress-text",attrs:{"title":_vm.ToolTip}},[_vm._v(_vm._s(_vm.CurrentItemsCount))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }